import { useEffect, useState, useContext, useRef } from 'react';
import { MyContext } from '../Context/MyProvider';
import ToastLogo from "../image/astrotalk-logo.png";
import { useTranslation } from 'react-i18next';
const ShowToast = () => {
    const { t } = useTranslation();

    const { istoast, setIsToast, toastmsg, setToastMsg } = useContext(MyContext);

    const [visible, setVisible] = useState(false);

    const ClassRef = useRef(null);
    const hideTimerRef = useRef(null);

    const startHideTimer = () => {
        hideTimerRef.current = setTimeout(() => {
            ClassRef.current?.classList.remove('open');
            setTimeout(() => {
                setVisible(false);
                setIsToast(false);
                setToastMsg("");
            }, 300);
        }, 3000);
    }

    useEffect(() => {
        if (istoast) {
            setVisible(true);
            setTimeout(() => {
                ClassRef.current?.classList.add('open');
            }, 50);
            startHideTimer();
        }

        return () => clearTimeout(hideTimerRef.current);

    }, [istoast]);

    if (!visible) return null;

    return (
        <div ref={ClassRef} onMouseEnter={() => clearTimeout(hideTimerRef.current)}
            onMouseLeave={startHideTimer}
            className="showtoast_page leading-5">
            <img src={ToastLogo} className='rounded-full' alt="ToastLogo" />
            {t(toastmsg)}
        </div>
    );
};

export default ShowToast;
